import header from "./modern-apartment-architecture.jpg";
import section1 from "./apartmentbuilding.jpg";
import section2 from "./hausmitbalkonen.webp";
import section3 from "./playground-between-houses.jpg";
import section4 from "./analog-landscape-city-with-buildings.jpg";
import section5 from "./Grundriss-Mehrfamilienhaus.jpg";
import section6 from "./analog-landscape-city-with-buildings-2.jpg";

export { header, section1, section2, section3, section4, section5, section6 };
